import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAccessToken } from './authHelper';
import 'bootstrap/dist/css/bootstrap.min.css';
import './tables.css';
import trackRecordIcon from "./static_files/track_records_check.svg";

// 安全处理 dateString 不存在/为 null 的情况
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const d = new Date(dateString.replace(' GMT', ''));
  const date = new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
  const options = {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };
  const formattedDate = date.toLocaleDateString('en-US', options).replace(/,/g, '');
  const formattedTime = date.toLocaleTimeString('it-IT');
  const [month, day, year] = formattedDate.split(' ');
  return `${day} ${month} ${year} ${formattedTime}`;
};

const formatToPercentage = (value) => {
  if (!value) return '0.00%';
  return `${(parseFloat(value) * 100).toFixed(2)}%`;
};

const formatPercentage = (value) => {
  if (!value) return '0.00%';
  return `${parseFloat(value).toFixed(2)}%`;
};

const formatPercentageAPY = (value) => {
  if (!value) return 'N/A';
  return `${(parseFloat(value) * 100).toFixed(2)}%`;
};

const formatToFourDigits = (value) => {
  if (!value) return '$0.0000';
  return parseFloat(value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 4
  });
};

const formatUSDI = (value) => {
  if (!value) return '0.0000';
  return parseFloat(value).toLocaleString('en-US', {
    maximumFractionDigits: 4,
    minimumFractionDigits: 4
  });
};

const TrackRecordsCheck = () => {
  const [data, setData] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);

  // 分页
  const [currentPage, setCurrentPage] = useState(1);
  // 这里只是示例，可根据需要改为 5、60 等
  const rowsPerPage = 5;

  useEffect(() => {
    fetchTrackRecordsCheck();
  }, []);

  const fetchTrackRecordsCheck = async () => {
    setLoading(true);
    try {
      const access_token = await getAccessToken();
      const response = await axios.get(
        'https://max1-funding-arb.uc.r.appspot.com/portfolio_track_records_check',
        { headers: { Authorization: `Bearer ${access_token}` } }
      );

      // 将后端返回的 data 用 "today_date" 排序，若为空则靠后/靠前处理
      const sortedData = response.data.sort((a, b) => {
        const dateA = a.today_date ? new Date(a.today_date) : 0;
        const dateB = b.today_date ? new Date(b.today_date) : 0;
        return dateB - dateA;
      });
      setData(sortedData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching track_records_check:', error);
      setMessage('Error fetching data.');
      setLoading(false);
    }
  };

  const handleApprove = async (recordId) => {
  const confirmResult = window.confirm(`Are you sure you want to approve record ID: ${recordId}?`);
  if (!confirmResult) {
    return;
  }

  try {
    const access_token = await getAccessToken();
    const { data } = await axios.get(
      `https://max1-funding-arb.uc.r.appspot.com/approve_portfolio/${recordId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }
    );

    if (data.status === 'success') {
      setMessage(data.message);
      fetchTrackRecordsCheck();
    } else {
      setMessage(data.message || 'Error approving record.');
    }
  } catch (error) {
    console.error('Error approving record:', error);
    setMessage('Error approving record.');
  }
};

  // 分页
  const totalPages = Math.ceil(data.length / rowsPerPage);
  const paginatedData = data.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  if (loading) {
    return (
      <div className="container">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="container" style={{marginBlock:"20px"}}>
       <div className="title-box d-flex justify-content-between align-items-center">
                <img className="green-title" src={trackRecordIcon} alt="" style={{width: "16vw"}}></img>
            </div>
      {message && <div className="alert alert-info">{message}</div>}

      <div className="table-responsive" style={{ borderColor: '#1F464D' }}>
        <table className="table table-striped table-bordered mt-3">
          <thead className="thead-dark">
            <tr>
              {/* 这里的列名根据你的需求更换 */}
              <th>Today Date</th>
              <th>Total Assets Value</th>
              <th>Portfolio Expected APR</th>
              <th>Portfolio Implied APR</th>
              <th>Portfolio Expected 30 Days Earnings</th>
              <th>Portfolio Implied 30 Days Earnings</th>
              <th>Net Exposure Value</th>
              <th>Money at Risk %</th>
              <th>One Dollar Value Growth</th>
              <th>Thirty Day Apy</th>
              <th>Ninety Day Apy</th>
              <th>USDI in Circulation</th>
              <th>Status</th>
              <th>Approve</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((record) => (
              <tr key={record.id}>
                {/* 这里用 record.today_date 渲染 */}
                <td>{formatDate(record.today_date)}</td>
                <td>{formatToFourDigits(record.total_assets_value)}</td>
                <td>{formatToPercentage(record.portfolio_expected_apr)}</td>
                <td>{formatToPercentage(record.portfolio_implied_apr)}</td>
                <td>{formatToFourDigits(record.portfolio_expected_30days_earnings)}</td>
                <td>{formatToFourDigits(record.portfolio_implied_30days_earnings)}</td>
                <td>{formatToFourDigits(record.net_exposure_value)}</td>
                <td>{formatPercentage(record.money_at_risk_percent)}</td>
                <td>{formatToFourDigits(record.dollar_value_growth)}</td>

                {/* 对空值的 thirty_day_apy / ninety_day_apy 做“N/A”处理 */}
                <td>{record.thirty_day_apy ? formatPercentageAPY(record.thirty_day_apy) : 'N/A'}</td>
                <td>{record.ninety_day_apy ? formatPercentageAPY(record.ninety_day_apy) : 'N/A'}</td>

                <td>{formatUSDI(record.usdi_in_circulation)}</td>
                <td>{record.status ?? 'N/A'}</td>
                <td>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleApprove(record.id)}
                  >
                    Approve
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <nav aria-label="Page navigation example" className="navbar-flexbox">
        <ul className="pagination">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => handlePageChange(1)}>
              First
            </button>
          </li>
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Previous
            </button>
          </li>
          {Array.from({ length: Math.min(4, totalPages) }, (_, i) => i + 1).map(
            (page) => (
              <li
                key={page}
                className={`page-item ${currentPage === page ? 'active' : ''}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              </li>
            )
          )}
          {totalPages > 4 && (
            <>
              <li className="page-item disabled">
                <span className="page-link">...</span>
              </li>
              <li
                className={`page-item ${
                  currentPage === totalPages ? 'active' : ''
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(totalPages)}
                >
                  {totalPages}
                </button>
              </li>
            </>
          )}
          <li
            className={`page-item ${
              currentPage === totalPages ? 'disabled' : ''
            }`}
          >
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next
            </button>
          </li>
          <li
            className={`page-item ${
              currentPage === totalPages ? 'disabled' : ''
            }`}
          >
            <button
              className="page-link"
              onClick={() => handlePageChange(totalPages)}
            >
              Last
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default TrackRecordsCheck;